import styled from 'styled-components'
import { buttonVariants, cn, iconButtonVariants } from '@cutilei/ui'

/*
  O visual do Button do @cutilei/ui para os botões que as telas definem no próprio styles.js. A
  definição continua um styled-component com o mesmo nome, e as telas não mudam:

    export const Button = styled(LookButton).attrs(buttonLook({ variant: 'secondary' }))`
      width: 200px;
      align-self: center;
    `

  - O visual vem das classes da lib, no tamanho `sm` (36 px); o CSS da definição fica só com o
    layout (largura, margens, encaixe no flex), porque ele vem depois das classes e as venceria.
  - `buttonLook` recebe `{ variant, destructive }` ou uma função das props, para quem escolhe a
    variante pela prop (`$danger`, por exemplo). `iconButtonLook` é o mesmo para os botões só de
    ícone, no tamanho `xs` (28 px).
  - O `type` de cada definição não muda: um botão sem tipo dentro do <Form> do Formik envia o
    formulário, e há telas que contam com isso.
*/

export const LookButton = styled.button`
  /* O spinner antigo (icons/loading.svg) é branco: aqui ele acompanha a cor do texto do botão. */
  circle {
    stroke: currentColor;
  }

  /*
    Os 36 px do sm também carregando: o spinner antigo tem 20 px, menos que a linha do texto. O
    link fica de fora, com os 24 px dele.
  */
  &[data-slot='button']:not([data-variant='link']) {
    min-height: 36px;
  }
`

const resolve = (look, props) => (typeof look === 'function' ? look(props) : look) ?? {}

/*
  O `data-slot` liga o reset da lib (borda, fundo e fonte do navegador zerados), que o site aplica
  só aos elementos da lib, porque não usa o preflight do Tailwind. O `cn` resolve as classes que
  brigam, como o padding do `sm` e o `p-0` do link.
*/
export function buttonLook(look) {
  return props => {
    const { variant = 'secondary', destructive = false } = resolve(look, props)
    return {
      'data-slot': 'button',
      'data-variant': variant,
      className: cn(buttonVariants({ variant, destructive, size: 'sm' }))
    }
  }
}

export function iconButtonLook(look) {
  return props => {
    const { variant = 'ghost', destructive = false, size = 'xs' } = resolve(look, props)
    return { 'data-slot': 'icon-button', className: cn(iconButtonVariants({ variant, destructive, size })) }
  }
}
